import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ContactContext from 'contexts/contactContext'
import { useContext } from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import TextButton from 'LuxKit/Button/TextButton'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'

interface Props {
  onBack: () => void
}

const StyledContactDiv = styled.div`
  background: ${props => props.theme.palette.neutral.surface.lightBackground};
  padding: ${rem(20)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const StyledDisclaimerTextBlock = styled(BodyTextBlock)`
  margin-top: ${rem(4)};
  margin-bottom: ${rem(16)};
  max-width: 80%;
`

function LuxPlusManageAccountModalUpdatePaymentMethodFailure(props: Props) {
  const { onBack } = props
  const intl = useIntl()
  const currentContact = useContext(ContactContext)
  const defaultContact = currentContact.defaultContact

  return <>
    <ModalHeader title={intl.formatMessage({
      id: 'a2DxfOiIqwHgXGvHt3ob',
      defaultMessage: 'We couldn’t update your payment method',
      description: 'Heading title for the payment method update failure modal',
    })}
    />
    <ModalBody>
      <ModalContent>
        <VerticalSpacer gap={20}>
          <BodyText variant="small">
            {intl.formatMessage({
              id: 'Ka_3pvJu67Fc3yCoUHym',
              defaultMessage: 'Please try again or use a different card.',
              description: 'Body text suggesting the user try again or use another card',
            })}
          </BodyText>
          <StyledContactDiv>
            <BodyTextBlock variant="large" weight="bold" align="center">
              {intl.formatMessage({
                id: 'WYNNI0-YTilP5f60BvDw',
                defaultMessage: 'Need help? Call our support team',
                description: 'Heading for the support contact section in the payment failure modal',
              })}
            </BodyTextBlock>
            <StyledDisclaimerTextBlock variant="medium" align="center">
              {intl.formatMessage({
                id: 'cGIeurGEZ4N8LF-6ji9p',
                defaultMessage: 'Our customer service team are available anytime, 24 hours, 7 days a week',
                description: 'Disclaimer text about customer service availability',
              })}
            </StyledDisclaimerTextBlock>
            <TextButton kind="secondary" href={`tel:${defaultContact.humanReadable}`}>{defaultContact.humanReadable}</TextButton>
          </StyledContactDiv>
          <Group direction="horizontal" horizontalAlign="end" gap={20}>
            <TextButton
              kind="primary"
              data-testid="luxplus-try-again"
              size="large"
              fit="mobile-full-width"
              id="luxplus-try-again-button"
              onClick={onBack}
            >
              {intl.formatMessage({
                id: 'P5jBZWWhnm-U0sQSfr5i',
                defaultMessage: 'Try again',
                description: 'Action button label to retry updating the payment method',
              })}
            </TextButton>
          </Group>
        </VerticalSpacer>
      </ModalContent>
    </ModalBody>
  </>
}

export default LuxPlusManageAccountModalUpdatePaymentMethodFailure
